<template lang="pug">
.page.page-experiment.pt-3
  .container
    h1 {{ $route.meta.h1 || $route.meta.title }}
    .row.mb-3
      .col-12.text-left
        span.tag.k-sketch Experiments · NYU era · 2018–2019
    .row
      .col-sm-2.col-lg-3.nav-exprs
        button.expr_nav.text-left(type='button', v-for='(expr,exprid) in experiments',
          :class="{active: exprid==currentIndex}", :aria-pressed="exprid==currentIndex"
          @click="selectExperiment(exprid)").mb-2
          .cover_sm(:style="{'background-image': 'url('+expr.cover+')'}")
            span {{expr.title}}
          //- pre {{expr.date}}
      .col-sm-10.col-lg-9
        h2 {{ experiment.title }}
        p {{ experiment.date }}
        .experiment-actions
          router-link.pill(:to="experiment.detailPath") {{ $i18n.locale === 'zh' ? '作品完整頁面 →' : 'Full artwork record →' }}
          a.pill(:href="experiment.src", target="_blank", rel="noopener noreferrer") {{ $i18n.locale === 'zh' ? '開啟原作 ↗︎' : 'Open original ↗︎' }}
        iframe(v-if="playing", :key="currentIndex", :src="experiment.embedUrl", :title="experiment.title", allow="autoplay; fullscreen", allowfullscreen)
        button.experiment-play(v-else="", type="button", @click="playing = true")
          img(:src="experiment.cover", :alt="experiment.title", loading="lazy")
          span {{ $i18n.locale === 'zh' ? '載入互動作品 ▶' : 'Load interactive work ▶' }}

</template>

<script>
import { withSlash } from '@/runtime/site-path.mjs'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n()
    return { t }
  },
  data(){
    return {
      currentIndex: 0,
      playing: false
    }
  },
  computed: {
    experiments() {
      // vue-i18n v9：陣列訊息要用 $tm，$t 只回字串（i18n 遷移漏改，整頁曾因此 render crash）
      const list = this.$tm('experiment.experimentsList') || []
      return list.map((item, index) => {
        const expData = this.experimentsData[index]
        return {
          title: item.title,
          date: item.date,
          src: expData.src,
          cover: expData.cover,
          embedUrl: expData.src.includes('openprocessing.org/sketch/') ? expData.src.replace(/\/$/, '') + '/embed/' : expData.src,
          detailPath: withSlash((this.$i18n.locale === 'zh' ? '/zh' : '') + (expData.src.includes('openprocessing.org/sketch/') ? '/sketch/' + expData.src.match(/sketch\/(\d+)/)[1] : '/work/codepen-' + expData.src.match(/embed\/([^?]+)/)[1].toLowerCase()))
        }
      })
    },
    experimentsData() {
      return [
        {
          src: "https://www.openprocessing.org/sketch/611472",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail611472@2x.jpg"
        },
        {
          src: "https://codepen.io/frank890417/embed/PypZeZ?default-tab=result",
          cover: "https://assets.codepen.io/396078/internal/screenshots/pens/PypZeZ.default.png"
        },
        {
          src: "https://www.openprocessing.org/sketch/700092",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail700092@2x.jpg"
        },
        {
          src: "https://www.openprocessing.org/sketch/598254",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail598254@2x.jpg"
        },
        {
          src: "https://www.openprocessing.org/sketch/708757",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail708757@2x.jpg"
        },
        {
          src: "https://www.openprocessing.org/sketch/676343",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail676343@2x.jpg"
        },
        {
          src: "https://codepen.io/frank890417/embed/rJXgOx?default-tab=result",
          cover: "https://assets.codepen.io/396078/internal/screenshots/pens/rJXgOx.default.png"
        },
        {
          src: "https://www.openprocessing.org/sketch/616561",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail616561@2x.jpg"
        },
        {
          src: "https://codepen.io/frank890417/embed/rKKGBY?default-tab=result",
          cover: "https://assets.codepen.io/396078/internal/screenshots/pens/rKKGBY.default.png"
        },
        {
          src: "https://codepen.io/frank890417/embed/wXgrer?default-tab=result",
          cover: "https://assets.codepen.io/396078/internal/screenshots/pens/wXgrer.default.png"
        },
        {
          src: "https://www.openprocessing.org/sketch/641437",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail641437@2x.jpg"
        },
        {
          src: "https://www.openprocessing.org/sketch/779854",
          cover: "https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail779854@2x.jpg"
        }
      ]
    },
    experiment(){
      return this.experiments[this.currentIndex]
    }
  },
  methods:{
    selectExperiment(index) { this.currentIndex = index; this.playing = false }
  }
}
</script>

<style lang="sass">
.page-experiment
  .container
    max-width: var(--content-w)
  iframe
    width: 100%
    height: 600px
    border: 0
    border-radius: var(--r-md)
  .experiment-actions
    display: flex
    flex-wrap: wrap
    gap: 12px
    margin-bottom: 24px
  .experiment-play
    display: grid
    width: 100%
    gap: 16px
    padding: 16px
    color: var(--ink)
    background: var(--bg1)
    border: 0
    border-radius: var(--r-lg)
    cursor: pointer
    transition: var(--t-hover)
    &:hover
      background: var(--bg2)
    img
      width: 100%
      max-height: 60vh
      object-fit: contain
  .nav-exprs
    height: 80vh
    overflow-y: auto
    overflow-x: hidden
  .expr_nav
    display: block
    border: 0
    background: var(--bg1)
    color: var(--ink)
    padding: 0
    width: 100%
    transition: var(--t-hover)
    border-radius: var(--r-md)
    overflow: hidden
    &:hover
      background-color: var(--bg2)
    &.active
      background-color: var(--bg2)
      .cover_sm
        filter: brightness(1)
        span
          background-color: var(--gold)
          color: black
  .cover_sm
    // width: 240px
    width: 100%
    // padding-top: 50%
    color: #eee9df
    padding: 35px 10px
    padding-bottom: 5px
    background-size: 100% auto
    cursor: pointer
    background-position: center center
    transition: background-size var(--dur-scene) var(--ease-out), filter var(--dur-quick) var(--ease-out), color var(--dur-quick) var(--ease-out)
    font-weight: 800

    &:hover
      background-size: 120%
      filter: brightness(1)
      color: var(--ink)
    span
      padding: 0px 5px
      font-weight: 500
      // transition: 0.5s

@media (max-width: 575px)
  .page-experiment .nav-exprs
    height: auto
    max-height: 35vh
    margin-bottom: 24px
</style>

<style scoped>
.cover_sm span { display:inline-block; background:#080808ed; color:#eee9df; padding:5px 8px; line-height:1.5; }
.expr_nav:focus-visible { outline:2px solid var(--gold); outline-offset:3px; }
@media(prefers-reduced-motion:reduce) { .expr_nav { transition:none; } }
</style>
